import {
  BlueBirdTheme, Button, Tooltip, Typography,
} from "@kitbird/core";
import { ColumnI } from "../../../components/Table/TableProps";
import { toRupiah, toStringDate } from "../../../utils/common";
import { ReactComponent as ShowIcon } from "../../../assets/icons/show_icon.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/cross_mark.svg";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow_right.svg";
import useReportReceiptSubmission from "./useReportReceiptSubmission";
import { CommonTrxTypes } from "../../../enums/common";

const { danger, gray, primary } = BlueBirdTheme.colors;

const columns = (
  { setModalConfig }: ReturnType<typeof useReportReceiptSubmission>,
): ColumnI[] => [{
  title: "No. pengajuan bon",
  dataIndex: "trx_id",
  key: "trx_id",
  width: "150px",
},
{
  title: "Tanggal pengajuan",
  dataIndex: "trx_date",
  key: "trx_date",
  sort: true,
  width: "160px",
  render: (item) => toStringDate(item),
},
{
  title: "Total bon & tipe transaksi",
  dataIndex: "trx_type_description",
  key: "trx_type_description",
  width: "175px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {toRupiah(row.amount || 0)}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {item}
      </Typography>
    </>
  ),
},
{
  title: "Deskripsi",
  dataIndex: "trx_text",
  key: "trx_text",
  width: "225px",
},
{
  title: "Pemohon & NIP",
  dataIndex: "employee_nip",
  key: "employee_nip",
  width: "125px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {row.employee_name}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {item}
      </Typography>
    </>
  ),
},
{
  title: "Departemen & jabatan",
  dataIndex: "department",
  key: "department",
  width: "155px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item.department}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {row.job_title}
      </Typography>
    </>
  ),
},
{
  title: "Segmen",
  dataIndex: "segment_desc",
  key: "segment_desc",
  width: "125px",
},
{
  title: "Wilayah & pool",
  dataIndex: "area_name",
  key: "area_name",
  width: "125px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {row.pool_id}
      </Typography>
    </>
  ),
},
{
  title: "Perusahaan & relasi",
  dataIndex: "company_code",
  key: "company_code",
  width: "145px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item}
      </Typography>
      <br />
      {row.company_relation && (
        <Typography level={7} color={gray.bodyText}>
          {row.company_relation}
        </Typography>
      )}
    </>
  ),
},
{
  title: "Akun GL",
  dataIndex: "trx_code",
  key: "trx_code",
  width: "175px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item.trx_code} • {CommonTrxTypes.find(
          (type) => type.value === row.sap_shkzg,
        )?.label}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {item.trx_desc}
      </Typography>
    </>
  ),
},
{
  title: "Rekening tujuan",
  dataIndex: "bank_account_name",
  key: "bank_account_name",
  width: "125px",
  render: (item, row) => (
    <>
      <Typography level={6} fontWeight="medium" color={gray.subtitle}>
        {item}
      </Typography>
      <br />
      <Typography level={7} color={gray.bodyText}>
        {row.bank_account}
      </Typography>
    </>
  ),
},
{
  title: "Estimasi tanggal kirim",
  dataIndex: "plan_postdate",
  key: "plan_postdate",
  sort: true,
  width: "175px",
  render: (item) => toStringDate(item),
},
{
  title: "Lampiran",
  dataIndex: "trx_files",
  key: "trx_files",
  width: "225px",
  render: (item) => (
    <div className="ellipsis-text" style={{ width: 200 }}>
      {item.file_text} {item.file_count > 1 && `+${item.file_count - 1}`}
    </div>
  ),
},
{
  title: "Action",
  dataIndex: "trx_id",
  key: "action",
  width: "140px",
  sticky: "right",
  render: (item, row) => (<div style={{ display: "flex", gap: 8 }}>
    <Button
      size="sm"
      backgroundColor={primary[300]}
      style={{ padding: 8 }}
      onClick={(e) => {
        e.stopPropagation();
        setModalConfig({ id: item as string, extendBm: row.extend_bm, type: "DETAIL" });
      }}
    >
      <ShowIcon />
    </Button>
    <Button
      size="sm"
      backgroundColor={danger[400]}
      style={{ padding: 8 }}
      onClick={(e) => {
        e.stopPropagation();
        setModalConfig({ id: item as string, extendBm: row.extend_bm, type: "REJECT" });
      }}
    >
      <CrossIcon />
    </Button>
    <Tooltip direction="bottom" tooltipContent="Proses transfer dana">
      <Button
        size="sm"
        backgroundColor="#58627A"
        style={{ padding: 8 }}
        onClick={(e) => {
          e.stopPropagation();
          setModalConfig({ id: item as string, extendBm: row.extend_bm, type: "APPROVE" });
        }}
      >
        <ArrowIcon />
      </Button>
    </Tooltip>
  </div>),
}];

export default columns;
